/**
 * The chamber a Provenir support officer is working in (D-031).
 *
 * Support has standing access to every chamber, but works inside one at a time. The choice is
 * kept per browser tab, so two tabs can work in two chambers, and sent with every request; the
 * server admits the request to that chamber and nothing else.
 */
export interface SupportChamber {
  id: string;
  slug: string;
  legalName: string;
  shortName: string;
  sandbox: boolean;
  logoUrl: string | null;
  primaryColor: string;
  secondaryColor: string;
}

const KEY = 'pv.supportChamber';

export function supportChamber(): SupportChamber | null {
  try {
    const raw = sessionStorage.getItem(KEY);
    return raw ? (JSON.parse(raw) as SupportChamber) : null;
  } catch {
    return null;
  }
}

export function setSupportChamber(chamber: SupportChamber | null): void {
  try {
    if (chamber) sessionStorage.setItem(KEY, JSON.stringify(chamber));
    else sessionStorage.removeItem(KEY);
  } catch {
    /* storage blocked: the choice lasts until the page reloads */
  }
}
